import React, { useState } from 'react';
import Observer from '@researchgate/react-intersection-observer';

interface IInViewObserverProps {
  render: (renderObject: any) => any;
}

/** IntersectionObserver wrapper which checks if it is in the viewport */
const InViewObserver: React.FC<IInViewObserverProps> = (props) => {
  const { render } = props;
  const [inView, setInView] = useState<boolean>(true);
  const [scrolledPassed, setScrolledPassed] = useState<boolean>(false);

  const handleIntersection = (args: IntersectionObserverEntry): void => {
    const { isIntersecting, boundingClientRect } = args;
    setInView(isIntersecting);
    setScrolledPassed(!isIntersecting && boundingClientRect.y < 0);
  };

  return (
    <Observer onChange={handleIntersection}>
      {render({ inview: inView, scrolledpassed: scrolledPassed })}
    </Observer>
  );
};

export default InViewObserver;
